import { compact } from 'lodash';

const GROUP_CATEGORY_LABELS = {
  year: 'Years',
  class: 'Classes',
  subject: 'Subjects',
  custom: 'Custom Groups'
};

const getGroupMappingChangeSummaryLines = (summary, categoryLabels = GROUP_CATEGORY_LABELS) => {
  if (!summary) {
    return { groupChanges: [], overallChanges: [] };
  }

  const groupChanges = Object.keys(categoryLabels)
    .filter((category) => summary[category].before > summary[category].after)
    .map((category) => ({
      label: categoryLabels[category],
      before: summary[category].before,
      after: summary[category].after
    }));

  const overallChanges = compact([
    summary.added > 0 && { label: 'Added', count: summary.added },
    summary.removed > 0 && { label: 'Removed', count: summary.removed },
    summary.updated > 0 && { label: 'Updated', count: summary.updated }
  ]);

  return { groupChanges, overallChanges };
};

export default {
  GROUP_CATEGORY_LABELS,
  getGroupMappingChangeSummaryLines
};
